import { useQuery } from "@tanstack/react-query";
import { getSettings } from "@/api/setting/setting";
import { useAuth } from "@/providers/auth";

const placeholderData = {
  logo: "",
  favicon: "",
  primary_color: "#000000",
  secondary_color: "",
  accent_color: "",
  client_name: "",
};

export const useSettings = ({ queryFn, queryKey, enabled, ...rest } = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false;

  return useQuery({
    queryKey: ["settings"],
    queryFn: () => fetchSettings(id),
    placeholderData,
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000,
    ...rest,
  });
};

const fetchSettings = async (id) => {
  const data = await getSettings(id);
  const newPlatformSettings = {
    ...JSON.parse(localStorage.getItem("platform_settings") || "{}"),
    pb_user: data,
  };
  localStorage.setItem(
    "platform_settings",
    JSON.stringify(newPlatformSettings)
  );
  return data;
};
